// For use with Alpine 3.13.x
(function () {
  const cartStore = {
    cart: window.cart,

    get totalPrice() {
      return this.cart?.total_price;
    },

    get itemCount() {
      return this.cart?.item_count;
    },

    get items() {
      return this.cart?.items;
    },
  };

  const productInterestStore = {
    async init() {
      if (window.customerId === undefined) {
        return;
      }

      let resp = await fetch(`https://cozy-earth-api.fly.dev/v1/customers/${window.customerId}/product-interests`);
      let json = await resp.json();
      this.productInterests = json;
      this.isLoaded = true;
    },

    productInterests: [],
    isLoaded: false,

    async productHandle(productId) {
      let resp = await fetch("https://cozyearth2.myshopify.com/api/2024-10/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "0ac50b4d55d0892d3774e8b95543d971",
        },
        body: JSON.stringify({
          operationName: "getProductHandleById",
          query: "query getProductHandleById($id: ID!) { product(id: $id) { handle } }",
          variables: {
            id: `gid://shopify/Product/${productId}`,
          },
        }),
      });
      let respJson = await resp.json();
      return respJson?.data?.product?.handle;
    },

    async refreshInterests() {
      let resp = await fetch(`https://cozy-earth-api.fly.dev/v1/customers/${window.customerId}/product-interests`);
      let json = await resp.json();
      this.productInterests = json;
    },

    getInterestId(productId, interest) {
      return this.productInterests.find((p) => p.productId === productId && p.interest === interest)?.interestId;
    },

    hasInterest(productId, interest) {
      return !!this.productInterests.find((p) => p.productId === productId && p.interest === interest);
    },

    async toggleInterest(productId, interest) {
      const interestId = this.getInterestId(productId, interest);

      if (this.hasInterest(productId, interest)) {
        await this.deleteInterest(interestId);
      } else {
        await this.createInterest(productId, interest);
      }
    },

    async createInterest(productId, interest) {
      if (window.customerId === undefined) {
        return;
      }

      await fetch(`https://cozy-earth-api.fly.dev/v1/customers/${window.customerId}/product-interests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          productId,
          interest,
        }),
      });
      await this.refreshInterests();
    },

    async deleteInterest(interestId) {
      if (window.customerId === undefined) {
        return;
      }

      await fetch(`https://cozy-earth-api.fly.dev/v1/customers/${window.customerId}/product-interests/${interestId}`, {
        method: "DELETE",
      });
      await this.refreshInterests();
    },
  };

  function registerAlpineStores() {
    Alpine.store("cart", cartStore);
    Alpine.store("productInterests", productInterestStore);
  }

  document.addEventListener("alpine:init", registerAlpineStores, { once: true });
})();
